import styled from 'styled-components'

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Container = styled.div`
  position: relative;
  background: white;
  padding: 32px 24px;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.1);
  outline: none;
`

export const IconWrap = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
`

export const Title = styled.h2`
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #2d2f48;
`

export const SubTitle = styled.p`
  text-align: center;
  font-size: 15px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.4;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  label {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 6px;
    color: #2d2f48;
  }
`

export const Input = styled.input`
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;

  &:disabled {
    background-color: #f5f5f5;
  }

  &::placeholder {
    color: #b0b0b0;
  }
`

export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`
